import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Fonts } from "@snapchat/snap-design-system";

export const datePickerContainer = css`
    min-width: 310px;
    margin-right: 24px;
`;

export const datePickerLabel = css`
    ${Fonts.Control.Label}
    display: flex;
    align-items: center;
    margin-bottom: 4px;
`;

export const buttonStyle = css`
    position: relative;

    display: flex;
    justify-content: space-between;

    padding: 14px 12px;

    font-weight: 400;

    border: 1px solid transparent;
    border-radius: 4px;

    :hover {
        border-color: ${Colors.Yellow.V200};
    }
`;

export const ScheduleDatePickerInputContainer = styled.div`
    width: 100%;

    button.ant-btn.sds-button {
        display: flex;
        justify-content: space-between;

        width: 100%;
        padding: 14px 12px;

        font-weight: 400;

        background-color: ${Colors.Gray.V50};
        border-radius: 4px;
        box-shadow: none;
    }
`;

export const popoverStyle = css`
    /* stylelint-disable selector-class-pattern */
    & .sds-date-range-picker-container .DayPicker.sds-date-range-picker .DayPicker-wrapper {
        padding-bottom: 0;
    }

    &:not(.ant-popover-hidden) {
        display: flex;
        align-items: flex-end;
        height: 275px;
        background: transparent;

        .ant-popover-inner-content {
            padding: 0;
            background: transparent;
            box-shadow: none;
        }
    }
`;
